import foodyAppIcon from "../assets/icons/foody-app-icon.svg";
import foodyMockup from "../assets/mockups/foody-mockup.png";
import trainsEscapeIcon from "../assets/icons/trainsescape-app-icon.svg";
import trainsEscapeMockup from "../assets/mockups/trainsescape-mockup.png";
import orbisLinesIcon from "../assets/icons/orbislines-app-icon.svg";
import orbisLinesMockup from "../assets/mockups/orbislines-mockup.png";

const publishedApps = [
  {
    name: "foody: wellness",
    visibleInHome: true,
    category: {
      en: "wellness",
      tr: "wellness",
    },
    description: {
      en: "snap a meal to see ingredients and calories, or scan barcodes for packaged foods",
      tr: "yemek fotoğrafı çekip içeriğini ve kalori bilgisini öğren, paketli gıdaları barkodla analiz et",
    },
    platform: "Android",
    tag: {
      en: "nutrition assistant",
      tr: "beslenme asistani",
    },
    detailPath: "/apps/foody",
    appStoreUrl: null,
    googlePlayUrl:
      "https://play.google.com/store/apps/details?id=com.wodaslabs.foody",
    logoPath: foodyAppIcon,
    mockupPath: foodyMockup,
  },
  {
    name: "trains escape",
    visibleInHome: true,
    category: {
      en: "logic puzzle",
      tr: "mantık bulmacası",
    },
    description: {
      en: "tap trains to move them in locomotive direction and clear the board in the correct order",
      tr: "trenlere dokun, lokomotif yönüne göre çıkart ve tahtayı doğru sırayla temizle",
    },
    platform: "iOS + Android",
    tag: {
      en: "train puzzle",
      tr: "tren bulmacası",
    },
    detailPath: "/apps/trainsescape",
    appStoreUrl: "https://apps.apple.com/us/app/trains-escape/id6761054738",
    googlePlayUrl:
      "https://play.google.com/store/apps/details?id=com.wodaslabs.trainsescape",
    logoPath: trainsEscapeIcon,
    mockupPath: trainsEscapeMockup,
  },
  {
    name: "Orbis Lines",
    visibleInHome: true,
    category: {
      en: "mobile puzzle game",
      tr: "mobil bulmaca oyunu",
    },
    description: {
      en: "move balls on a 9x9 board, form lines of 5 or more matching colors, and keep the board open",
      tr: "9x9 tahtada topları hareket ettir, aynı renkten 5 veya daha fazla topu hizala ve tahtada boş alan bırak",
    },
    platform: "iOS + Android",
    tag: {
      en: "classic lines puzzle",
      tr: "klasik lines bulmacası",
    },
    detailPath: "/apps/orbislines",
    appStoreUrl: "https://apps.apple.com/us/app/orbis-lines/id6773422684",
    googlePlayUrl:
      "https://play.google.com/store/apps/details?id=com.wodaslabs.orbislines",
    logoPath: orbisLinesIcon,
    mockupPath: orbisLinesMockup,
  },
];

const upcomingApps = [];

const stats = [
  {
    value: "12+",
    label: {
      en: "published apps",
      tr: "yayınlanan app",
    },
  },
  {
    value: "4.8",
    label: {
      en: "average rating",
      tr: "ortalama puan",
    },
  },
  {
    value: "1.2M",
    label: {
      en: "downloads",
      tr: "indirme",
    },
  },
];

export { publishedApps, upcomingApps, stats };
